import ServiceLayout from "../components/ServiceLayout";

export default function UIUX(){
  return(
    <ServiceLayout
      title="UI/UX Design"
      subtitle="Design experiences users love."
      gradient="linear-gradient(135deg,#f7971e,#ffd200)"
      features={[
        "User Research",
        "Wireframing",
        "Prototypes",
        "Design Systems",
        "Interaction Design",
        "Usability Testing"
      ]}
    />
  );
}
